/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {FC} from 'react'
import {ErrorMessage, useFormikContext } from 'formik'
import { MyEditor } from '../../../apps/components/MyEditor';
import SimpleLoader from '../../../apps/components/SimpleLoader';

type Props = {
  values:any,
  submitLoader: boolean;
  disableFormFields: boolean;
}

const PrivateSectorOpportunities: FC<Props> = ({values,submitLoader,disableFormFields}) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div className='w-100 position-relative'>
      {submitLoader && <SimpleLoader />}
      <div className='mb-10 fv-row mt-5'>
        <MyEditor disabled={disableFormFields} value={values.private_sector_opportunities} setValue={(value:string)=>{
          setFieldValue("private_sector_opportunities", value);
        }} /> 
        <div className='text-danger mt-2'>
          <ErrorMessage name='private_sector_opportunities' />
        </div>      
      </div>

    </div>
  )
}

export {PrivateSectorOpportunities}
